import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


interface SheetModalEvent {
  data: Array<string>;
  action: string;
}

@Injectable({
  providedIn: 'root'
})
export class SplitSheetModalService {
  modals: Array<string> = [];
  navModal: Array<string> = [];
  modalSubject: Subject<SheetModalEvent> = new Subject<SheetModalEvent>();
 

  constructor() { }

  public open(name: string, params: any = {}) {
    this.navModal.push(name);
    this.modalSubject.next(<SheetModalEvent>{
      data: this.navModal,
      action: "OPEN"
    });
  }

  public push(name: string, params: any = {}) {
    this.navModal.push(name);
    this.modalSubject.next(<SheetModalEvent>{
      data: this.navModal,
      action: "PUSH"
    });
  }

  public pop() {
    if(this.navModal.length > 1) {
      this.navModal.pop();
      this.modalSubject.next(<SheetModalEvent>{
        data: this.navModal,
        action: "POP"
      });
    }
  }

  public close(name: string) {
    if(this.navModal.indexOf(name) != -1) {
      this.navModal = [];
      this.modalSubject.next(<SheetModalEvent>{
        data: this.navModal,
        action: "CLOSE"
      });;
    }
  }
}
